import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  props: {
    errors: Object,
  },
})
export default class BbFormComponent extends Vue {
  formEl = null;
  isSubmitted = false;

  mounted() {
    this.onFormSubmitted = this.onFormSubmitted.bind(this);
    this.formEl =
      this.$el.tagName === 'FORM' ? this.$el : this.$el.querySelector('form');
    this.formEl.noValidate = true;
    this.formEl.addEventListener('submit', this.onFormSubmitted);
  }

  onFormSubmitted(event) {
    event.preventDefault();
    this.isSubmitted = true;
    this.getFields().forEach(ctrl => {
      ctrl.formSubmitted();
    });
    if (!this.formEl.checkValidity || this.formEl.checkValidity()) {
      this.$emit('submit', event);
    } else {
      this.focusErrorField();
    }
  }

  @Watch('errors')
  onErrorsChanged() {
    this.getFields().forEach(ctrl => {
      const fieldKey = this.errors && ctrl.fieldNames.find(n => this.errors[n]);
      ctrl.setErrors(fieldKey && this.errors[fieldKey]);
    });
    this.focusErrorField();
  }

  getFields() {
    return Array.from(this.formEl.querySelectorAll('.BbField')).map(
      e => e.bbFieldCtrl,
    );
  }

  focusErrorField() {
    this.getFields().some(ctrl => {
      const { isValid } = ctrl;
      if (!isValid) {
        ctrl.focus();
      }
      return !isValid;
    });
  }
}
